import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { ModeService } from "src/app/utils/mode.service";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import {
  deleteSubscription,
  upsertSubscription,
} from "../../ngrx/settings.action";
import { SubscriptionDto } from "../../interfaces/subscription_dto";

@Component({
    selector: "app-subscription-dialog",
    templateUrl: "./subscription-dialog.component.html",
    styleUrls: ["./subscription-dialog.component.scss"],
    imports: [IonicModule, CommonModule, ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionDialogComponent implements OnInit {
  readonly subscription = input<SubscriptionDto>(undefined);

  constructor(
    public modeService: ModeService,
    private modalController: ModalController,
    private store: Store<any>
  ) {}

  subscriptionForm: FormGroup;

  ngOnInit() {
    this.initializeForm();
    this.subscriptionForm.patchValue(this.subscription());
  }

  private initializeForm() {
    this.subscriptionForm = new FormGroup({
      name: new FormControl("", [Validators.required]),
      prize: new FormControl("", [Validators.required, Validators.min(0)]),
      lessons: new FormControl("", [Validators.required, Validators.min(1)]),
    });
  }
  save() {
    if (this.subscriptionForm.valid) {
      const subscription = this.subscription();
      if (subscription?.subscription_id) {
        const updatedSubscription = {
          ...subscription,
          ...this.subscriptionForm.value,
        };
        this.store.dispatch(
          upsertSubscription({ subscription: updatedSubscription })
        );
      } else {
        this.store.dispatch(
          upsertSubscription({ subscription: this.subscriptionForm.value })
        );
      }
    }
    this.modalController.dismiss();
  }
  delete() {
    this.store.dispatch(
      deleteSubscription({ subscriptionId: this.subscription().subscription_id })
    );
    this.modalController.dismiss();
  }
  cancel() {
    this.modalController.dismiss();
  }

  updateForm() {
    const name = this.subscriptionForm.get("lessons").value + "er Abo";
    this.subscriptionForm.patchValue({ name });
  }
}
